import React from 'react';
import { connect } from 'react-redux';
import cookie from "js-cookie";
import { productUrl } from '../../helpers/itineraryHelper';

const Breadcrumb = (props) => {

    return (
        <div className={`breadcrumb ${props.clazz}`}>
            <div className="max-width-5 mx-auto">
                <div className="clearfix">
                <div className="col col-12 px2">
                    <ul>
                        {
                            props.type === "fixed" && 
                            <>
                                <li>
                                    <a href="https://www.busabout.com/trips" target="_self">Trips</a>
                                </li>
                                <li>
                                    <a href={productUrl(props.departure)} target="_self">Departure</a>
                                </li>
                                <li className={props.view === "payment" ? 'active no-pointer-event' : ''}>Payment</li>
                                <li className={props.view === "confirmation" ? 'active no-pointer-event' : ''}>Confirmation</li>
                            </>
                        }

                        {
                            props.type === "ap" && 
                            <>
                                <li>
                                    <a href={process.env.REACT_APP_PLANNER_URL} target="_self">Planner</a>
                                </li>
                                <li className={props.view === 'itinerary' ? `active no-pointer-event` : '' }>
                                    <a href={`${process.env.REACT_APP_PLANNER_URL}${process.env.REACT_APP_ITINERARY_PAGE}?id=${props.uuid}&t=${cookie.get("ap.token")}`} target="_self">Itinerary</a>
                                </li>
                                <li className={props.view === "payment" ? `active no-pointer-event` : '' }>
                                    Payment
                                </li>
                                <li className={props.view === "confirmation" ? `active no-pointer-event` : ''}>Confirmation</li>
                            </>
                        }
         
                    </ul>
                </div>
                </div>
            </div>     
        </div>
    )
} 

const mapStateToProps = state => {
    return{
        uuid:state.currentBooking.uuid
    }
}

export default connect(mapStateToProps, null)(Breadcrumb);



